import React from 'react';
import { ERROR, HEADING_3, DOTS, MEDIUM} from '../../../helpers/constants';
import '../../../style/premiumSettingsWizard.css';
import { COUNTRY, CANADA_COUNTRY, CURRENCY, PERCENTAGE_SYMBOL } from '../../../helpers/variables';
import { FormGroup, HorizontalRule, Alert, Table, Heading, Loader } from 'arag-ui-lib';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import WordingExtraIdentifiers from './wordingExtraIdentifiers';
import { formattedMoney } from '../../../helpers/functions';
import { getStepMessage } from '../../../helpers/premiumSettingsFunctions';
import { getFieldStyles } from '../../../helpers/applicationPremiumSettingsFunctions';

const SharedStep6 = (props) => {
	const {
        showTable,
        badResponseMsg,
        posting,
        limitOfIndemnity,
        recoverableRatePercentage,
        notes,
        endorsements,
        comments,
        currentStep,
        displayedCoverageType,
        displayedDeductible,
        displayedEndorsement,
        isApplicationPremium,
        isPercentagePremium,
        topHeader,
        groups,
        columns,
        data,
        verticalHeaders,
		patching,
		appPremiumSettingsIndicator,
        stepMessages,
        loiTestId,
        notesTestId,
        commentsTestId,
        endorsementsTestId,
        tableTestId,
        highlightedColumns,
        outerVerticalHeaders,
        validFromLabel,
        highlightedRows,
        emphasizedFields,
        highlightedFields,
        coverageTestId,
        deductiblesTestId,
	} = props;
    if(currentStep !== 6)
        return null;
	const stepMessage = getStepMessage('6', stepMessages);
    const loiValue = formattedMoney(limitOfIndemnity, CURRENCY);
    const percentageValue = formattedMoney(recoverableRatePercentage, '');
    return (
        <>
            {
                showTable
                ?
                    null
                :
                    <Heading
                        variant={HEADING_3}
                        title={stepMessage}
                        headingTestId={'edit-application-premium-setting-instructions'}
                    />
            }
			{!isApplicationPremium 
			?
				<FormGroup
					labelSize={"col-sm-3"}
					inputSize={"col-sm-6"}
					label={CONTENT_STRINGS.VALID_FROM}
					variant={FORM_GROUP_VARIANTS.PLAIN}
					inputProps={{
                        id: 'validFrom',
                        name: 'validFrom',
                        label: validFromLabel 
                    }}
					formGroupTestId={'premium-settings-setting-valid-from'}
				/>
			:
				null
			}
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.LIMIT_OF_INDEMNITY}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: 'limitOfIndemnity',
                    name: 'limitOfIndemnity',
                    label: loiValue,
                    additionalStyle: getFieldStyles('limitOfIndemnity', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={loiTestId}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.NOTES}
                variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                inputProps={{
                    id: 'notes',
                    name: 'notes',
                    value: notes,
                    disabled: true,
                    rows: 2,
                    onChange: () => {},
                    additionalStyle: getFieldStyles('notes', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={notesTestId}
            />
            <FormGroup
                labelSize={"col-sm-3"}
                inputSize={"col-sm-6"}
                label={CONTENT_STRINGS.COMMENTS}
                variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                inputProps={{
                    id: 'comments',
                    name: 'comments',
                    value: comments,
                    disabled: true,
                    rows: 2,
                    onChange: () => {},
                    additionalStyle: getFieldStyles('comments', emphasizedFields, highlightedFields),
                }}
                formGroupTestId={commentsTestId}
            />
            {
                COUNTRY === CANADA_COUNTRY 
                ?
                    <WordingExtraIdentifiers
                        displayedCoverageType={displayedCoverageType}
                        displayedDeductible={displayedDeductible}
                        displayedEndorsement={displayedEndorsement}
                        coverageTestId={coverageTestId}
                        deductiblesTestId={deductiblesTestId}
                        endorsementsTestId={endorsementsTestId}
                        emphasizedFields={emphasizedFields}
                        highlightedFields={highlightedFields}
                        isApplicationPremium={isApplicationPremium}
                        showTable={showTable}
                    />
                :
                    <FormGroup
                        labelSize={"col-sm-3"}
                        inputSize={"col-sm-6"}
                        label={CONTENT_STRINGS.ENDORSEMENTS}
                        variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                        inputProps={{
                            id: 'endorsements',
                            name: 'endorsements',
                            value: endorsements || '',
                            disabled: true,
                            onChange: () => {},
                            additionalStyle: getFieldStyles('endorsements', emphasizedFields, highlightedFields),
                        }}
                        formGroupTestId={endorsementsTestId}
                    />
            }
            <div className="row">
                <div className="col-sm-12">
                    <HorizontalRule />
                </div>
            </div>
			{
				isPercentagePremium
				?  
					<FormGroup
						labelSize={"col-sm-3"}
						inputSize={"col-sm-6"}
						label={CONTENT_STRINGS.RECOVERABLE_RATE}
						variant={FORM_GROUP_VARIANTS.PLAIN}
						inputProps={{
                            id: 'recoverableRate',
                            name: 'recoverableRate',
                            label: `${percentageValue}${PERCENTAGE_SYMBOL}`,
                            additionalStyle: getFieldStyles('recoverableRatePercentage', emphasizedFields, highlightedFields),
                        }}
						formGroupTestId={'application-premium-settings-recoverable-rate'}
					/> 
				: 
					null
			}
			<div>
				<Table
					columns={columns}
					data={data}
					striped
					topHeader={topHeader}
					groups={groups}
					verticalHeader={verticalHeaders}
					tableWrapperTestId={tableTestId}
					responsive
                    highlightedColumns={highlightedColumns}
                    outerVerticalHeader={outerVerticalHeaders}
                    highlightedRows={highlightedRows}
				/>
			</div>
			{(posting || patching || appPremiumSettingsIndicator)
				?
					<Loader variant={DOTS} dotSize={MEDIUM}/>
				:
					null
			}
			{
				badResponseMsg !== '' 
				?
					<Alert variant={ERROR} label={badResponseMsg} />
				:
                    null
			}
        </>
    );
};

export default SharedStep6;